import React, { type ReactNode } from "react";
import { LoadingOverlay } from "src/components/LoadingOverlay/LoadingOverlay.tsx";

export type FormLoadingOverlayProps = {
  title: ReactNode;
  isLoading: boolean;
};

export const DataGridLoadingOverlay = ({
  title,
  isLoading,
}: FormLoadingOverlayProps) => {
  return (
    <LoadingOverlay.Root isLoading={isLoading}>
      <LoadingOverlay.Spinner />
      <LoadingOverlay.Title>{title}</LoadingOverlay.Title>
    </LoadingOverlay.Root>
  );
};
